import { render, staticRenderFns } from "./DeviceSeries.vue?vue&type=template&id=b94368f8&scoped=true&"
import script from "./DeviceSeries.vue?vue&type=script&lang=js&"
export * from "./DeviceSeries.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSeries.vue?vue&type=style&index=0&id=b94368f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94368f8",
  null
  
)

export default component.exports